<template>
  <EhouseCalculatingDetail />
</template>

<script>
import EhouseCalculatingDetail from "@/components/Calculatings/EhouseCalculating/Detail.vue";
export default {
  components: { EhouseCalculatingDetail },
};
</script>

<style></style>
